/**
 * StandFiltreleri.jsx — the "Filtreler" panel of the staff Standlar list (backlog #69, 2026-10-20).
 *
 * The search box stays on the toolbar; every OTHER filter lives here, behind the "Filtreler" button (the same pattern as
 * Kişi Listesi's KisiFiltreleri), so a new filter is one more entry in the page's `filtreler` array instead of one more
 * control spread across the top bar. The panel knows nothing about stands: the page hands it the definitions.
 *
 *   filtreler  [{ key, tip: "select" | "switch", etiket,
 *                 secenekler?: [{ value, label }]   (select only; no options = the filter is hidden, e.g. the list could not be read)
 *                 tumuEtiketi?: string }]           (select only; the "everything" option)
 *   deger      { [key]: "" | string | boolean }     the page's filter state, one entry per key
 *   onChange   (key, value) => void
 *
 * A new filter also needs its request parameter in standlarListService.getTumStandlarList / standOverviewService (the page
 * spreads its filter state into that call, so the name of `key` is the name of the parameter).
 */
import React from "react";
import { Row, Col, Input, Label } from "reactstrap";

/** Is this filter doing something? A switch when on, a select when something is chosen. */
export function filtreAktifMi(filtre, value) {
  return filtre.tip === "switch" ? value === true : value !== "" && value != null;
}

/** How many filters are doing something (the badge on the button). */
export function aktifFiltreSayisi(filtreler, deger) {
  return filtreler.filter((f) => filtreAktifMi(f, deger[f.key])).length;
}

export default function StandFiltreleri({ filtreler, deger, onChange }) {
  const gorunen = filtreler.filter((f) => f.tip === "switch" || (f.secenekler && f.secenekler.length > 0));
  return (
    <Row className="g-3 align-items-end">
      {gorunen.map((f) => (
        f.tip === "switch" ? (
          <Col key={f.key} xs="auto" className="d-flex align-items-center pb-2">
            <div className="form-check form-switch mb-0">
              <Input
                type="switch" id={`flt-${f.key}`} className="form-check-input"
                checked={deger[f.key] === true} onChange={(e) => onChange(f.key, e.target.checked)}
              />
              <label className="form-check-label" htmlFor={`flt-${f.key}`}>{f.etiket}</label>
            </div>
          </Col>
        ) : (
          <Col key={f.key} lg={3} md={6}>
            <Label className="form-label small text-muted mb-1" htmlFor={`flt-${f.key}`}>{f.etiket}</Label>
            <Input type="select" id={`flt-${f.key}`} value={deger[f.key] ?? ""} onChange={(e) => onChange(f.key, e.target.value)}>
              <option value="">{f.tumuEtiketi}</option>
              {f.secenekler.map((o) => <option key={o.value} value={o.value}>{o.label}</option>)}
            </Input>
          </Col>
        )
      ))}
    </Row>
  );
}
